import Font from '../font';

<template>
  <@form.fieldset
    @titleKey='text'
    @isClosed={{true}}
    @showSelectedAttributesIndicator={{true}}
    as |fieldset|
  >
    <Font
      @fieldset={{fieldset}}
      @elementConfig={{@elementConfig}}
      @mlp={{@mlp}}
      @prefix='font'
    />
    <fieldset.field @property='options.fontColor' @type='color' />
    <fieldset.field @property='options.fontLinkColor' @type='color' />
    <fieldset.field @property='options.fontLinkColorHover' @type='color' />
  </@form.fieldset>
</template>
